import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ProductLineImage } from '@modeso/types__dgoods-products';
import { ShopProductLine } from '../../models/shopProductLine.interface';
export interface IDigitalProductTileDelegate {
    onTileClick(productLine: ShopProductLine): void;
}

@Component({
    selector: 'modeso-digital-product-tile',
    templateUrl: './digital-product-tile.component.html',
    styleUrls: ['./digital-product-tile.component.scss'],
})
export class DigitalProductTileComponent implements OnChanges {
    @Input() product: ShopProductLine | null = null;
    @Input() delegate?: IDigitalProductTileDelegate;
    @Output() imageLoaded: EventEmitter<string> = new EventEmitter<string>();
    cssClassName: string | undefined;
    image: ProductLineImage | undefined;

    ngOnChanges() {
        this.cssClassName = this.getCssClasses();
        this.image = this.getImage();
    }

    onClick(): void {
        if (this.delegate != null) {
            this.delegate.onTileClick(this.product);
        }
    }

    onImageLoad(imageSrc: string): void {
        this.imageLoaded.emit(imageSrc);
    }

    private getCssClasses(): string {
        if (!this.product.isGreyedOut && !this.product.blocked) {
            return 'modeso-digital-product-tile';
        } else {
            return 'modeso-digital-product-tile blocked-product-line';
        }
    }

    private getImage(): ProductLineImage {
        const fallbackImage: ProductLineImage = { frontImage: 'assets/placeholder.png', imageSize: null };

        const masterImage = this.product.productLineImages.find((img) => img.imageSize === 'MASTER_IMAGE');
        if (masterImage != null) {
            return masterImage;
        }

        const largeImage = this.product.productLineImages.find((img) => img.imageSize === 'LARGE');
        if (largeImage != null) {
            return largeImage;
        }
        return fallbackImage;
    }
}
